import UserSelectorPosition from './src/main';

/* istanbul ignore next */
UserSelectorPosition.install = function(Vue) {
  Vue.component(UserSelectorPosition.name, UserSelectorPosition);
};

export default UserSelectorPosition;
